import { render, staticRenderFns } from "./MyShippingDetails.vue?vue&type=template&id=1ad960e0&"
import script from "./MyShippingDetails.vue?vue&type=script&lang=js&"
export * from "./MyShippingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports